import React from "react";
import PropTypes from "prop-types";
import MuiMenu from "@material-ui/core/Menu";
import {
  MenuItem,
  CircularProgress,
  Checkbox,
  Switch,
} from "@material-ui/core";
import { observer } from "mobx-react";
import SubMenuItem from "./SubMenuItem";
import AntSwitch from "../AntSwitch";
import { isElement } from "react-is";
import transparentLoader from "./transparentLoader.gif";
import styled from "styled-components";

class Menu extends React.Component {
  renderMenuItems = () => {
    const me = this,
      {
        menuItems,
        isNotificationEnabled = false,
        valueKey = "key",
        displayKey = "name",
        isCheckBox = false,
        checkedValues = [],
        filteredColumnTypes = [],
        filterFunction,
        isLoading = false,
        isAddColumnLookupPopup = false,
        forDuplication = false,
        forMail = false
      } = this.props;
    let menuItemsSet = new Set(),
      menuItemsFiltered = menuItems,
      isLookupColumnInSubsheetView = false;

    if (isLoading) {
      return (
        <MenuItem>
          <CircularProgress size={18} />
        </MenuItem>
      );
    }

    if (!menuItems) {
      return <MenuItem disabled>No Data</MenuItem>;
    }

    menuItemsFiltered = menuItemsFiltered.filter(function (menuItem) {
      if (isElement(menuItem)) {
        return true;
      }

      if (!menuItem) {
        return false;
      }
      if (menuItemsSet.has(menuItem[valueKey])) {
        return false;
      }

      if (filterFunction && !filterFunction(menuItem)) {
        return false;
      }

      if (menuItem.hasOwnProperty('name') && menuItem.name == "CurrentJSONData" && window.appStore?.currentViewStore?.listConfig?.list?.is_log_sheet == 1 ) {
        return false;
      }

      menuItemsSet.add(menuItem[valueKey]);
      return true;
    });

    if (menuItemsFiltered.length === 0) {
      return <MenuItem>No more columns</MenuItem>;
    }

    return menuItemsFiltered.map((menuItem, index) => {
      // let options = Ext.decode(menuItem.options),
      // isChecked = checkedValues.indexOf(menuItem[valueKey]) !== -1;
      // within renderMenuItems method
      let options;
      if (isNotificationEnabled) {
        options = Ext.decode(menuItem.options)? Ext.decode(menuItem.options) : menuItem.options 
      } else {
        options = Ext.decode(menuItem.options); 
      }
      let isChecked = checkedValues.indexOf(menuItem[valueKey]) !== -1;
      if (isElement(menuItem)) {
        return menuItem;
      }

      if (menuItem.isTitledItem) {
        if (index != 0) {
          return (
            <>
              <Separator></Separator>
              <Title>{menuItem[displayKey]}</Title>
            </>
          );
        }
        return <Title>{menuItem[displayKey]}</Title>;
      }

      options = options?.[0];
      if (
        menuItem.column_type_id == "10" &&
        window.appStore?.currentViewStore?.view?.type == "table" &&
        window.appStore?.currentViewStore?.view?.list_id &&
        window.appStore?.currentViewStore?.view?.options?.main_list_id &&
        window.appStore?.currentViewStore?.view?.list_id !=
          window.appStore?.currentViewStore?.view?.options?.main_list_id &&
        !this.props?.forMail
      ) {
        isLookupColumnInSubsheetView = true;
      }
      if (!isLookupColumnInSubsheetView && (menuItem.subMenuItems || (options && options.source_list_id && !isAddColumnLookupPopup && !forDuplication))) {
        return (
          <SubMenuItem
            key={menuItem[valueKey]}
            caption={menuItem[displayKey]}
            menuItems={menuItem.subMenuItems}
            listId={options?.source_list_id}
            valueKey={valueKey}
            displayKey={displayKey}
            onMenuItemClick={(item) => me.onMenuItemClick(item)}
            parentMenuItem={menuItem}
            isLocal={menuItem.isLocal}
            aliasPrefix={menuItem[valueKey]}
            isCheckBox={isCheckBox}
            checkedValues={checkedValues}
            isLoading={menuItem.isLoading}
            isChecked={isChecked}
            filterFunction={filterFunction}
            loadingMenuItems={this.props.loadingMenuItems}
            isClickEnablesMenu={me.props.isClickEnablesMenu}
            name={me.props.name ?? menuItem.name}
            anchorOrigin={this.props.anchorOrigin}
            transformOrigin={this.props.transformOrigin}
            isNotificationEnabled={isNotificationEnabled}
          />
        );
      }

      return (
        <MenuItem
          key={menuItem[valueKey]}
          name={me.props.name ?? menuItem.name}
          onClick={(e) => me.onMenuItemClick(menuItem, e)}
          style={{
            paddingRight: 26,
          }}
        >
          {isCheckBox &&
          this.props?.loadingMenuItems?.has(menuItem.alias_path) ? (
            <StyledImage src={transparentLoader} alt="loading..."></StyledImage>
          ) : isCheckBox ? (
            <AntSwitch
              size="small"
              color="primary"
              checked={isChecked}
              onChange={() => {
                //dosomething
              }}
            />
          ) : null}
          {menuItem[displayKey]}
          {menuItem.isLoading && <CircularProgress size={18} />}
        </MenuItem>
      );
    });
  };

  onMenuItemClick = (menuItem = {}, e) => {
    const { onMenuItemClick = () => {} } = this.props,
      fn = menuItem.onClick || onMenuItemClick;
    if (
      e?.view?.appStore?.currentViewStore?.view?.type == "table" &&
      e?.view?.appStore?.currentViewStore?.view?.list_id &&
      e?.view?.appStore?.currentViewStore?.view?.options?.main_list_id &&
      e?.view?.appStore?.currentViewStore?.view?.list_id !=
        e?.view?.appStore?.currentViewStore?.view?.options?.main_list_id
    ) {
      if (menuItem.alias_path && typeof menuItem.alias_path == "string") {
        var arr = menuItem.alias_path.split(".");
        menuItem.alias_path = arr
          .filter(function (value, index, self) {
            return self.indexOf(value) === index;
          })
          .join(".");
        menuItem.alias_name = menuItem.alias_path;
      }
    }
    fn(menuItem, e);
  };

  render() {
    const {
      anchorElement,
      open,
      onClose,
      handleClose = () => {},
      header,
      anchorOrigin = {},
      transformOrigin = {},
      MenuItemsWrapper = React.Fragment,
    } = this.props;

    return (
      <MuiMenu
        anchorEl={anchorElement}
        open={open}
        onClose={onClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
          ...anchorOrigin,
        }}
        getContentAnchorEl={null}
        PaperProps={{
          style: {
            maxHeight: `420px`,
          },
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
          ...transformOrigin,
        }}
      >
        {this.renderMenuItems()}
      </MuiMenu>
    );
  }
}

const StyledImage = styled.img`
  height: 17px;
  width: 17px;
`;

const Separator = styled.div`
  border-bottom: 1px solid #c4c4c4;
  margin: 10px 0px;
`;

const Title = styled.div`
  margin: 6px 26px 6px 16px;
  color: #a1a1a1;
`;
export default observer(Menu);
